var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V32H0z",
    transform: "translate(0 -224) translate(0 48) translate(0 8) translate(0 168)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 8.25v7.5h7.5v-7.5h-7.5zm6 6h-4.5v-4.5h4.5v4.5zm8.25-4.5v-1.5h-3V6c0-.828-.672-1.5-1.5-1.5h-2.25v-3h-1.5v3h-4.5v-3h-1.5v3H6c-.828 0-1.5.672-1.5 1.5v2.25h-3v1.5h3v4.5h-3v1.5h3V18c0 .828.672 1.5 1.5 1.5h2.25v3h1.5v-3h4.5v3h1.5v-3H18c.828 0 1.5-.672 1.5-1.5v-2.25h3v-1.5h-3v-4.5h3zM18 18H6V6h12v12z",
    transform: "translate(0 -224) translate(0 48) translate(0 8) translate(0 168) translate(16 16)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevices);
export default __webpack_public_path__ + "static/media/icon-devices.2b5adcc626a69c71ae8f4899dc9e39d3.svg";
export { ForwardRef as ReactComponent };